import axios from "axios";
import { ApiReqBaseUrl } from "../assets/GlobalVariables";
import { saveDynamicPackage } from "./dynamicService";
import { withFlightsModuleProposalOnly, withFlightsNewSavePayload } from "../config/flightsModuleLds";

/**
 * Book flights only (standalone flight booking)
 * Uses the dynamic package service but with flights only (no hotel)
 */
export const bookFlightOnly = async (data) => {
  try {
    // Use saveDynamicPackage with flights only
    // The backend should handle deal_type: "Flights" to create flight-only orders
    return await saveDynamicPackage(
      withFlightsNewSavePayload({
        ...data,
        hotel: null,
        hotelOffer: null,
        flights: withFlightsModuleProposalOnly(data.flights),
      })
    );
  } catch (err) {
    console.error("Error booking flight:", err);
    throw err;
  }
};

/**
 * Get flight order by ID
 */
export const getFlightOrder = async (data) => {
  try {
    return await axios.post(`${ApiReqBaseUrl}/getDynamicOrder`, data);
  } catch (err) {
    console.error("Error getting flight order:", err);
    throw err;
  }
};

/**
 * Get flight orders by agent ID
 */
export const getFlightOrders = async (data) => {
  try {
    return await axios.post(`${ApiReqBaseUrl}/getDynamicOrdersByAgentId`, {
      ...data,
      deal_type: "Flights", // Filter for flight-only orders
    });
  } catch (err) {
    console.error("Error getting flight orders:", err);
    throw err;
  }
};


